// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different app types
 * @enum
 */
export enum AppType {
    Community = "community",
    Edge = "edge",
    EdgeChromium = "edgeChromium",
    Finance = "finance",
    FirstParty = "firstParty",
    HomePage = "homePage",
    Hub = "hub",
    MicrosoftNews = "microsoftNews",
    MMX = "mmx",
    NewsAndInterests = "newsAndInterests",
    Office = "office",
    qna = "qna",
    Recipes = "recipes",
    SharedWidgets = "sharedWidgets",
    SuperApp = "superApp",
    Shopping = "shopping",
    Traffic = "traffic",
    UGC = "ugc",
    Views = "views",
    Weather = "weather",
    Windows = "windows",
    WindowsNewsPlus = "windowsNewsPlus",
    WindowsShell = "windowsShell"
}

/**
 * Card style mode
 */
export enum CardStyleMode {
    Default = "Default",
    WinDashboard = "WinDashboard",
    Edge = "Edge"
}
